/**
 * Loads JavaScript and wraps with a Promise, which resolves on load.
 *
 * Consider using `defer: true` for non-essential scripts that may be loading while the page is getting parsed.
 * However, within Paper Culture code, that code should typically not be loaded until tier 3 anyway, at which
 * point defer won't have any impact.
 */
export const loadScript = (
  src: string,
  attributes?: {
    id?: string
    defer?: boolean
    className?: string
  }
): Promise<Event> => {
  return new Promise<Event>((resolve, reject) => {
    const element = document.createElement('script')
    Object.assign(element, {
      ...attributes,
      src,
      onload: resolve,
      onerror: reject
    })
    // There will always be script tag, because this code is loaded via script tag
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const firstScript = document.getElementsByTagName('script')[0]!
    // Script tag will always exist if this is being executed.
    // This uses the same widely deployed method that GA and GTM use.
    // https://www.stevesouders.com/blog/2010/05/11/appendchild-vs-insertbefore/
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    firstScript.parentNode!.insertBefore(element, firstScript)
  })
}
